import styled from 'styled-components';

export const FloatingBubblesContainerBox = styled.div`
  position: fixed;
  bottom: 30%;
  right: 16px;
  z-index: 10;
  
  @media ${({theme}) => theme.mediaQuery.mAndBelow} {
    right: 0px;
  }
`;
